import useCompanionAccess from '../hooks/useCompanionAccess';
import {
  Avatar,
  Badge,
  Checkbox,
  CircularProgress,
  FormControl,
  InputLabel,
  ListItemText,
  Menu,
  MenuItem,
  Button as MuiButton,
  Select,
  Typography,
  styled,
} from '@mui/material';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { toLower, upperFirst } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useDelayedLoading } from '../hooks/useDelayedLoading';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { pictos } from '../assets/img/pictos';
import Chemin from '../components/Chemin';
import ErrorPopup from '../components/ErrorPopup';
import Navigation from '../components/Navigation';
import SearchInput from '../components/SearchInput';
import { PoliceDefaut, PoliceDefautBold } from '../helpers/contants';
import {
  participantSelectRedux,
  participantsCategories,
  participantsFiltre,
  participantsRedux,
  participantsReduxPage,
} from '../redux/evenementsServices';
import {
  setParticipantsCache,
  setParticipantsFilter,
  setParticipantsNavigation,
} from '../redux/evenementsSlice';
import { centreInterets, envoyerDemandeRedux, refreshToken } from '../redux/profilService';
import '../styles/participants.css';
import textConnect from '../textConnect.json';
import { categories, formatFonction, formatName } from './fonctions';
import { ListItemSkeleton } from '../components/skeletons';

const Participants = props => {
  const { isCompanion, requireAccount } = useCompanionAccess();
  // const listeParticipantsInit = useSelector(state => state.evenements.participants)

  const evenementSelected = useSelector(state => state.evenements.evenementSelect);
  const [selectProfil, setSelectProfil] = useState('');

  const monProfil = useSelector(state => state.profil.profil);
  const accessToken = useSelector(state => state.user.access);
  const refresh_token = useSelector(state => state.user.refresh);

  const dispatch = useDispatch();
  const navigationPage = useNavigate();
  const listeParticipantsInit = useSelector(state => state.evenements.participants?.results ?? []);
  // const listeParticipantsInit = useSelector((state) =>
  //   state.evenements.participants.results.filter(
  //     (item) => item.id !== monProfil.id
  //   )
  // );
  const pagesNav = useSelector(state => state.evenements.participants?.total_pages ?? 1);
  const participantsTotalCount = useSelector(state => state.evenements.participants?.count ?? 0);
  const participantsFilterSaved = useSelector(state => state.evenements.participantsFilter);
  const participantsCache = useSelector(state => state.evenements.participantsCache);

  const location = useLocation();
  const breadcrumbs_temp = [
    {
      url: evenementSelected?.id ? `/dashboard/${evenementSelected.id}` : '/',
      nom: 'Accueil',
    },
    { url: location.pathname, nom: 'Participants' },
  ];

  // const [listeParticipantsFiltreInit, setlisteParticipantsFiltreInit] = useState(listeParticipantsInit.filter(item => item.id !== monProfil.id))
  // const [listeParticipantsFiltre, setListeParticipantsFiltre] = useState(listeParticipantsFiltreInit)

  const [openError, setOpenError] = useState(false);
  const [msgError, setMsgError] = useState('');

  const closeErrorHandle = () => {
    setOpenError(false);
  };

  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(false);
  const showLoading = useDelayedLoading(loading, 500);

  const [filtreMot, setFiltreMot] = useState(participantsFilterSaved?.filtreMot ?? '');
  const filterRequestRef = useRef(null);
  //Fonction filtre barre de recherche
  async function filtreParticipants(e) {
    const value = e.target.value;
    setFiltreMot(value);
    if (value.length > 1 || value.length === 0) {
      setPage(1);
    }
  }

  // function FiltrerProfil(categorie = [], tableau = []) {

  //     let resultat = []
  //     if (categorie.length > 1) {

  //         // console.log('superieur a 1..................')
  //         // console.log(categorie)
  //         let tabTemp = []

  //         for (let index = 0; index < categorie.length; index++) {
  //             // console.log('itemeeee', categorie[index])
  //             tableau.filter(item =>
  //                 item.profil.description.includes(categorie[index])).map((item2) =>
  //                     tabTemp.push(item2)
  //                 )

  //             resultat = tabTemp
  //             console.log(resultat)

  //         }

  //     }
  //     else {

  //         resultat = tableau.filter(item =>
  //             item.profil.description.includes(categorie)
  //         )
  //     }

  //     if (expertCheck) {
  //         resultat = tableau.filter(item =>
  //             item.is_expert === expertCheck
  //         )
  //     }
  //     // if (expertCheck === false) {
  //     //     resultat = tableau.filter(item =>
  //     //         item.is_expert === expertCheck
  //     //     )
  //     // }

  //     // console.log('le resultat : ', resultat)
  //     setListeParticipantsFiltre(resultat)
  //     // setAnchorEl(null)
  // }

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const savedCatCheckRef = React.useRef([]);
  const savedInterestCheckRef = React.useRef([]);
  const savedExpertCheckRef = React.useRef(false);
  const savedPageRef = React.useRef(1);
  const handleClick = event => {
    savedCatCheckRef.current = [...catCheck];
    savedInterestCheckRef.current = [...interestCheck];
    savedExpertCheckRef.current = expertCheck;
    savedPageRef.current = page;
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setCatCheck(savedCatCheckRef.current);
    setInterestCheck(savedInterestCheckRef.current);
    setExpertCheck(savedExpertCheckRef.current);
    setPage(savedPageRef.current);
    setAnchorEl(null);
  };
  const handleApplyClose = () => {
    setAnchorEl(null);
  };
  function annulerFiltre() {
    setExpertCheck(false);
    setCatCheck([]);
    setInterestCheck([]);
    setAnchorEl(null);
    setLoading2(true);
    setPage(1);
    const controller = new AbortController();
    participantsFiltre(
      accessToken,
      evenementSelected.id,
      '',
      filtreMot,
      false,
      controller,
      []
    ).then(reponse => {
      dispatch({
        type: 'evenements/addParticipants',
        payload: reponse.data,
      });
      navigationPage('/participants');
      setLoading2(false);
    });
  }

  const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 19,
    height: 19,
    left: -5,
    // border: `2px solid ${theme.palette.background.paper}`,
  }));

  const [catCheck, setCatCheck] = useState(participantsFilterSaved?.catCheck ?? []);
  const [interestCheck, setInterestCheck] = useState(participantsFilterSaved?.interestCheck ?? []);
  const [centresInteretList, setCentresInteretList] = useState([]);
  const [expertCheck, setExpertCheck] = useState(participantsFilterSaved?.expertCheck ?? false);
  const expCheck = e => {
    if (e.target.checked) {
      setExpertCheck(true);
      setPage(1);
    } else {
      setExpertCheck(false);
      setPage(1);
    }
  };
  const handleCheck = (e, value) => {
    if (e.target.checked) {
      setCatCheck(old => [...old, value]);
      setPage(1);
    } else {
      setCatCheck(catCheck.filter(item => item !== value));
      setPage(1);
    }
  };
  const [netStatus, setNetStatus] = useState(() => {
    if (navigator.onLine) {
      console.log('Connected to network.');
      return true;
    } else {
      return false;
    }
  });

  useEffect(() => {
    window.ononline = e => {
      console.log('Connected to network.');
      setNetStatus(true);
    };
    window.onoffline = e => {
      console.log('Network connection lost.');
      setNetStatus(false);
    };
  }, [netStatus]);
  useEffect(() => {
    const accueilUrl = evenementSelected?.id ? `/dashboard/${evenementSelected.id}` : '/';
    dispatch({
      type: 'Profil/addChemin',
      payload: [
        { url: accueilUrl, nom: 'Accueil' },
        { url: location.pathname, nom: 'Participants' },
      ],
    });
  }, [location.pathname, evenementSelected?.id, dispatch]);

  useEffect(() => {
    if (isCompanion) return;
    centreInterets(accessToken)
      .then(res => setCentresInteretList(Array.isArray(res?.data) ? res.data : []))
      .catch(() => setCentresInteretList([]));
  }, [accessToken, dispatch, isCompanion]);
  useEffect(() => {
    const controller = new AbortController();
    const requestSignature = JSON.stringify({
      filtreMot,
      catCheck: [...catCheck].sort(),
      expertCheck,
      interestCheck: [...(interestCheck || [])].sort(),
    });
    filterRequestRef.current = requestSignature;
    setLoading2(true);

    participantsFiltre(
      accessToken,
      evenementSelected.id,
      toLower(catCheck.join('-')),
      filtreMot,
      expertCheck,
      controller,
      interestCheck
    )
      .then(response => {
        if (filterRequestRef.current !== requestSignature) {
          setLoading2(false);
          return;
        }
        setLoading2(false);
        dispatch({
          type: 'evenements/addParticipants',
          payload: response.data,
        });
      })
      .catch(erreur => {
        setLoading2(false);
        if (erreur?.name === 'AbortError') {
          return;
        }
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }

        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');

              setLoading2(false);
            });
          }
        }
        // else {
        //   setMsgError(textConnect.internet);
        //   setOpenError(true);
        // }
      });

    return () => {
      controller.abort();
    };
  }, [
    accessToken,
    catCheck,
    dispatch,
    evenementSelected.id,
    expertCheck,
    filtreMot,
    interestCheck,
    netStatus,
    refresh_token,
  ]);

  // useEffect(() => {
  //   setLoading2(true);
  //   axios.interceptors.response.use(
  //     function (config) {
  //       // faire quelque chose avant que la requête ne soit envoyée
  //       controller.abort();
  //       // console.log(config)
  //       return config;
  //     },
  //     function (error) {
  //       // faire quelque chose en cas d’erreur
  //       return Promise.reject(error);
  //     }
  //   );

  //   cancelParticipantsRedux(
  //     accessToken,
  //     evenementSelected.id,
  //     filtreMot,
  //     controller
  //   )
  //     .then(async (response) => {
  //       // alert(response.data)
  //       // console.log(response.data)

  //       setLoading2(false);
  //       await dispatch({
  //         type: "evenements/addParticipants",
  //         payload: response.data,
  //       });
  //       // await participantSearch(accessToken, evenementSelected.id, filtreMot).then((response) => {
  //       //     // console.log(response)
  //       //     setLoading2(false)
  //       //     dispatch({

  //       //         type: 'evenements/addParticipants',
  //       //         payload: response.data

  //       //     })
  //       // })
  //     })
  //     .catch((erreur) => {
  //       setLoading2(false);
  //       if (!netStatus) {
  //         setMsgError(textConnect.internet);
  //         setOpenError(true);
  //       }
  //       if (erreur.response) {
  //         if (erreur.response.status !== 401) {
  //           setMsgError(textConnect.error);
  //           setOpenError(true);
  //         }
  //         if (erreur.response.status === 401) {
  //           refreshToken(refresh_token).then(async (reponse) => {
  //             dispatch({
  //               type: "user/addRefresh",
  //               payload: reponse.data.refresh,
  //             });
  //             dispatch({
  //               type: "user/addAccess",
  //               payload: reponse.data.access,
  //             });
  //             console.log("token refresh...");

  //             setLoading2(false);
  //           });
  //         }
  //         // else {
  //         //   setMsgError(textConnect.internet);
  //         //   setOpenError(true);
  //         // }
  //       }
  //     });
  // }, [filtreMot]);

  const [catList, setCatList] = useState([]);
  const [, setTotalPages] = useState(1);

  useEffect(() => {
    // Check if there are saved filters (e.g. coming back from participant detail).
    // When filters are active, the filter useEffect already fetches the correct
    // filtered data — skip the unfiltered fetch to avoid a race condition that
    // would overwrite the filtered results with the full list.
    const hasActiveFilters =
      participantsFilterSaved?.filtreMot ||
      participantsFilterSaved?.catCheck?.length > 0 ||
      participantsFilterSaved?.expertCheck ||
      participantsFilterSaved?.interestCheck?.length > 0 ||
      (participantsFilterSaved?.page && participantsFilterSaved.page > 1);

    const cached = !hasActiveFilters && participantsCache?.[evenementSelected?.id];

    const fetchParticipants = hasActiveFilters
      ? Promise.resolve(null)
      : cached
      ? Promise.resolve(cached).then(data => {
          dispatch({ type: 'evenements/addParticipants', payload: data });
          setTotalPages(data.total_pages);
        })
      : participantsRedux(accessToken, evenementSelected.id).then(reponse => {
          dispatch({
            type: 'evenements/addParticipants',
            payload: reponse.data,
          });
          dispatch(setParticipantsCache({ eventId: evenementSelected.id, data: reponse.data }));
          setTotalPages(reponse.data.total_pages);
        });

    fetchParticipants
      .then(() => participantsCategories(accessToken, evenementSelected.id))
      .then(response => {
        setCatList(response.data);
        setLoading(false);
      })
      .catch(erreur => {
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }

        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');
            });
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- initial load only
  }, []);

  const participantSelect = (token, id) => {
    if (requireAccount('Fiche participant')) return;
    setLoading(true);
    // participantEvenementSelectRedux
    participantSelectRedux(token, id, evenementSelected.id)
      .then(reponse => {
        dispatch({
          type: 'evenements/addParticipantSelect',
          payload: reponse.data,
        });
        navigationPage(`/compteParticipant/${id}/0`);
        setLoading(false);
        window.scrollTo(0, 0);
      })
      .catch(erreur => {
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }

        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');

              setLoading(false);
              participantSelect(token, id);
            });
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        setLoading(false);
      });
  };
  const [openEnvoyerDemande, setOpenEnvoyerDemande] = useState(false);

  const [circle, setCircle] = useState(false);
  const ouvrirEnvoyer = async (id, position) => {
    if (requireAccount('Contacts')) return;
    // console.log(id)
    setSelectProfil(id);
    setPositionUser([position, null]);
    console.log(positionUser);

    setOpenEnvoyerDemande(true);
  };
  const [positionUser, setPositionUser] = useState([]);
  const handleEnvoiDemande = () => {
    setCircle(true);
    envoyerDemandeRedux(accessToken, selectProfil, evenementSelected.id)
      .then(reponse => {
        setCircle(false);
        setPositionUser(positionUser.filter(val => val !== null));
        setOpenEnvoyerDemande(false);
        console.log('demande envoyé :', reponse.data);
        // participantsRedux(accessToken, evenementSelected.id).then((reponse) => {
        //     dispatch(
        //         {
        //             type: 'evenements/addParticipants',
        //             payload: reponse.data
        //         }
        //     );

        // }).catch((erreur) => {
        //     if (erreur.request) {
        //         if (erreur.request.status === 0) {
        //             console.log(erreur.request)
        //             setMsgError('Vérifiez votre connexion internet')
        //             setOpenError(true)
        //         }
        //     }

        //     if (erreur.response) {
        //         if (erreur.response.status !== 401) {
        //             setMsgError("Une erreur s'est produite")
        //             setOpenError(true)
        //         }

        //     }

        // })

        // participantsRedux(accessToken, dispatch, evenementSelected.id)
      })
      .catch(erreur => {
        setCircle(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');

              setLoading(false);
              handleEnvoiDemande();
            });
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };

  // useEffect(() => {
  //     axios.get(`${URL}/v1/api/evenements/${evenementSelected.id}/participants`).then((response) => {
  //         console.log(response)
  //     })
  // }, [page])

  const pageChange = async value => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
    setLoading2(true);
    const controller = new AbortController();

    participantsReduxPage(
      accessToken,
      evenementSelected.id,
      value,
      toLower(catCheck.join('-')),
      expertCheck,
      controller,
      filtreMot,
      interestCheck
    )
      .then(response => {
        setPage(value);
        setPositionUser([]);
        dispatch({
          type: 'evenements/addParticipants',
          payload: response.data,
        });
        setLoading2(false);
      })
      .catch(erreur => {
        setLoading2(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');
              pageChange(value);
            });
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };
  const [page, setPage] = useState(participantsFilterSaved?.page ?? 1);
  useEffect(() => {
    dispatch(
      setParticipantsFilter({
        catCheck,
        interestCheck,
        expertCheck,
        filtreMot,
        page,
      })
    );
  }, [dispatch, catCheck, interestCheck, expertCheck, filtreMot, page]);

  useEffect(() => {
    return () => {
      const pathname = window.location.pathname;
      const isBackToParticipantDetail = pathname.includes('/compteParticipant/');
      if (!isBackToParticipantDetail) {
        dispatch(
          setParticipantsFilter({
            catCheck: [],
            interestCheck: [],
            expertCheck: false,
            filtreMot: '',
            page: 1,
          })
        );
      }
    };
  }, [dispatch]);
  const handleChangePage = (event, value) => {
    // alert(value);

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
    setLoading2(true);
    const controller = new AbortController();

    participantsReduxPage(
      accessToken,
      evenementSelected.id,
      value,
      toLower(catCheck.join('-')),
      expertCheck,
      controller,
      filtreMot,
      interestCheck
    )
      .then(response => {
        setPage(value);
        setPositionUser([]);
        dispatch({
          type: 'evenements/addParticipants',
          payload: response.data,
        });
        setLoading2(false);
        // dispatch()
      })
      .catch(erreur => {
        setLoading2(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');
              pageChange(value);
            });
          }
        }
      });
  };

  return (
    <Container fluid className="" style={{ width: '100%' }}>
      <Modal
        className="d-flex align-items-center"
        show={openEnvoyerDemande}
        onHide={() => setOpenEnvoyerDemande(false)}
        style={{ fontFamily: PoliceDefaut }}
      >
        <Modal.Header
          closeVariant="white"
          closeButton
          style={{ color: 'white', backgroundColor: '#134491' }}
        >
          <h4>Confirmation</h4>
        </Modal.Header>
        <form>
          <Modal.Body>
            Voulez-vous vraiment envoyer une demande ?
            <div className="d-flex justify-content-end mt-3">
              {circle ? (
                <CircularProgress />
              ) : (
                <Button className="btn-recup" onClick={() => handleEnvoiDemande()}>
                  Confirmer
                </Button>
              )}

              <Button
                className="btn-recup2 mx-2"
                variant="secondary"
                onClick={() => setOpenEnvoyerDemande(false)}
              >
                Fermer
              </Button>
            </div>
          </Modal.Body>
        </form>
      </Modal>

      <ErrorPopup message={msgError} open={openError} close={() => closeErrorHandle()} />

      <Row>
        <Navigation
          button={true}
          titre={'Participants'}
          icone={pictos.participant_rond_icone}
          evenement={evenementSelected.photo}
          photo={monProfil.photo_path}
          retour="dashboard"
          selected={1}
          open={(!open).toString()}
          menus={true}
        />
      </Row>

      <Row className="p-0">
        <Chemin breadCrumbs={breadcrumbs_temp} />
      </Row>
      <Menu
        className="menu-filtre"
        id="filtre-menu"
        aria-labelledby="btn-filtre"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            minWidth: 260,
            width: 260,
            maxWidth: 260,
          },
        }}
      >
        <Typography className="mx-3 border-bottom" style={{ fontFamily: PoliceDefautBold }}>
          {' Filtrer par catégorie :'}
        </Typography>

        {catList.map((item, index) => {
          const isChecked = catCheck.filter(cat => cat === item.nom).length > 0;
          const inputId = `category-${index}-${item.nom}`;
          return (
            <MenuItem
              key={index}
              className=""
              style={{ fontFamily: PoliceDefaut, cursor: 'pointer' }}
              onClick={e => {
                e.stopPropagation();
                handleCheck({ target: { checked: !isChecked } }, item.nom);
              }}
            >
              <Col
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleCheck({ target: { checked: !isChecked } }, item.nom);
                }}
              >
                <label
                  htmlFor={inputId}
                  style={{ cursor: 'pointer', marginBottom: 0 }}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleCheck({ target: { checked: !isChecked } }, item.nom);
                  }}
                >
                  {upperFirst(toLower(item.nom))}
                </label>
              </Col>
              <Col className="" sm="auto" onClick={e => e.stopPropagation()}>
                <input
                  id={inputId}
                  checked={isChecked}
                  type="checkbox"
                  name=""
                  onChange={e => handleCheck(e, item.nom)}
                  onClick={e => e.stopPropagation()}
                />
              </Col>
            </MenuItem>
          );
        })}

        <MenuItem
          className=""
          style={{ fontFamily: PoliceDefaut, cursor: 'pointer' }}
          onClick={e => {
            e.stopPropagation();
            expCheck({ target: { checked: !expertCheck } });
          }}
        >
          <Col
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              expCheck({ target: { checked: !expertCheck } });
            }}
          >
            <label
              htmlFor="category-expert"
              style={{ cursor: 'pointer', marginBottom: 0 }}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                expCheck({ target: { checked: !expertCheck } });
              }}
            >
              Expert
            </label>
          </Col>
          <Col className="" sm="auto" onClick={e => e.stopPropagation()}>
            <input
              id="category-expert"
              checked={expertCheck === true}
              type="checkbox"
              name=""
              onChange={e => expCheck(e)}
              onClick={e => e.stopPropagation()}
            />
          </Col>
        </MenuItem>
        {centresInteretList.length > 0 ? (
          <>
            <Typography
              className="mx-3 mt-2 border-bottom"
              style={{ fontFamily: PoliceDefautBold }}
            >
              Filtrer par centres d&apos;intérêt :
            </Typography>
            <MenuItem disableRipple sx={{ display: 'block' }} onClick={e => e.stopPropagation()}>
              <FormControl fullWidth size="small" sx={{ minWidth: 220 }}>
                <InputLabel
                  id="participants-interest-select-label"
                  style={{ fontFamily: PoliceDefaut }}
                >
                  Centres d&apos;intérêt
                </InputLabel>
                <Select
                  labelId="participants-interest-select-label"
                  multiple
                  value={interestCheck}
                  label="Centres d'intérêt"
                  onChange={e => setInterestCheck(e.target.value)}
                  renderValue={selected =>
                    selected.length === 0
                      ? 'Aucun'
                      : selected.length <= 2
                      ? selected.map(t => upperFirst(toLower(t))).join(', ')
                      : `${selected.length} sélectionné(s)`
                  }
                  MenuProps={{
                    disableScrollLock: true,
                    PaperProps: { sx: { maxHeight: 220 } },
                  }}
                  sx={{ fontFamily: PoliceDefaut }}
                >
                  {centresInteretList.map(label => (
                    <MenuItem key={label} value={label}>
                      <Checkbox
                        checked={interestCheck.indexOf(label) > -1}
                        sx={{ padding: '4px 8px 4px 0' }}
                      />
                      <ListItemText
                        primary={upperFirst(toLower(label))}
                        primaryTypographyProps={{ fontFamily: PoliceDefaut }}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </MenuItem>
          </>
        ) : null}
        <MenuItem className="border-top py-2" sx={{ display: 'block' }} disableRipple>
          <Row className="g-2 w-100 m-0">
            <Col xs={6} className="p-0 pr-1">
              <MuiButton
                fullWidth
                variant="contained"
                size="small"
                onClick={() => handleApplyClose()}
                sx={{
                  fontFamily: PoliceDefautBold,
                  borderRadius: 0,
                  textTransform: 'none',
                }}
              >
                Afficher {participantsTotalCount ?? listeParticipantsInit?.length ?? 0}
              </MuiButton>
            </Col>
            <Col xs={6} className="p-0 pl-1">
              <MuiButton
                fullWidth
                variant="outlined"
                size="small"
                onClick={() => annulerFiltre()}
                sx={{
                  fontFamily: PoliceDefaut,
                  borderRadius: 0,
                  textTransform: 'none',
                }}
              >
                Réinitialiser
              </MuiButton>
            </Col>
          </Row>
        </MenuItem>
      </Menu>
      {showLoading ? (
        <ListItemSkeleton count={6} />
      ) : (
        <Row className="container-participants d-flex justify-content-center">
          <Row className="mb-4 recherche-container-participant d-flex align-items-center justify-content-center">
            <SearchInput
              placeholder={'Rechercher un participant'}
              filtre={filtreParticipants}
              value={filtreMot}
            />

            <Col
              sm="auto"
              className=""
              style={{ width: 'fit-content', cursor: 'pointer' }}
              aria-controls={open ? 'filtre-menu' : undefined}
              aria-haspopup={true}
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <Row
                className="d-flex justify-content-center"
                style={{ textAlign: 'center', height: '20px', margin: '' }}
              >
                {' '}
                {'Filtrer'}{' '}
              </Row>
              <img
                className="row"
                src={pictos.filtrer_icone}
                alt=""
                style={{ width: '30px', margin: 'auto' }}
              />
            </Col>
          </Row>

          <Row className="">
            {/* {listeParticipantsInit.filter((item) => {
                            return filtreMot.toLowerCase() === '' ? item : (toNormalForm(item.nom.toLowerCase()).includes(toNormalForm(filtreMot.toLowerCase())) || toNormalForm(item.prenom.toLowerCase()).includes(toNormalForm(filtreMot.toLowerCase())) || toNormalForm(item.fonction.toLowerCase()).includes(toNormalForm(filtreMot.toLowerCase())) || toNormalForm(item.organisation.nom.toLowerCase()).includes(toNormalForm(filtreMot.toLowerCase())))
                        }).map((item, index) => */}
            {listeParticipantsInit.map((item, index) => (
              <Row
                key={index}
                className="participant-item d-flex align-items-center"
                style={{ textDecoration: 'none' }}
              >
                <NavLink
                  className="d-flex col align-items-center justify-content-start"
                  style={{ textDecoration: 'none', width: 'fit-content' }}
                  onClick={() => {
                    // Store navigation context before navigating
                    const participantIds = listeParticipantsInit.map(p => p.id);
                    const totalCount = pagesNav * listeParticipantsInit.length; // Estimation
                    dispatch(
                      setParticipantsNavigation({
                        ids: participantIds,
                        currentIndex: index,
                        context: {
                          currentPage: page,
                          totalPages: pagesNav,
                          totalCount: totalCount,
                          pageSize: listeParticipantsInit.length,
                        },
                      })
                    );

                    participantSelect(accessToken, item.id);
                  }}
                >
                  <Col
                    sm="auto"
                    className="photo-profil-participant"
                    style={{ paddingRight: '15px' }}
                  >
                    <Badge
                      className="d-flex align-items-center justify-content-start"
                      style={{ width: '', left: '-8px' }}
                      overlap="circular"
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                      badgeContent={categories(
                        item.profil.photo,
                        item.profil.description,
                        item.is_expert,
                        item.is_speaker
                      ).map((item2, index) => (
                        <SmallAvatar
                          title={item2.title}
                          key={index}
                          className="col p-0"
                          src={item2.icone}
                          alt=""
                          style={{
                            width: '20px',
                            height: '20px',
                            marginLeft: '',
                          }}
                        />
                      ))}
                    >
                      <Avatar
                        id="photoProfil"
                        className="avatar-profil"
                        src={item.photo_path}
                        style={{ width: '', height: '', backgroundColor: '' }}
                      />
                    </Badge>
                  </Col>
                  <Col className="">
                    <Row className="noms-participant" style={{}}>
                      <Col style={{ fontWeight: 'bold' }}>{formatName(item.prenom, item.nom)}</Col>{' '}
                    </Row>
                    <Row>
                      <Col>{formatFonction(item.fonction)}</Col>
                    </Row>
                    <Row>
                      <Col>
                        {item.raison_sociale === undefined ||
                        item.raison_sociale === '' ||
                        item.raison_sociale === null
                          ? !item.from_structure
                            ? upperFirst(item.organisation.nom.toLowerCase())
                            : upperFirst(item.organisation.adresse_organisation.ville.toLowerCase())
                          : upperFirst(item.raison_sociale.toLowerCase())}
                      </Col>
                    </Row>
                  </Col>
                </NavLink>
                <Col
                  sm="auto"
                  className="d-flex justify-content-end "
                  style={{ width: 'fit-content' }}
                >
                  {item.is_contact_status === 'pending' ||
                  (positionUser.length === 1 && positionUser[0] === index) ? (
                    <img src={pictos.demande_attente_icone} alt="" style={{ width: '30px' }} />
                  ) : item.is_contact_status === 'accepted' ? (
                    <img src={pictos.demande_valide_icone} alt="" style={{ width: '30px' }} />
                  ) : item.is_contact_status === 'invite' ? (
                    <NavLink onClick={() => ouvrirEnvoyer(item.id, index)}>
                      <img
                        title="Ajouter"
                        src={pictos.ajout_contact_icone}
                        alt=""
                        style={{ width: '30px' }}
                      />
                    </NavLink>
                  ) : null}
                </Col>
              </Row>
            ))}
          </Row>
          {listeParticipantsInit.length === 0 ? (
            <p
              className=""
              style={{
                textAlign: 'center',
                color: '#134491',
                fontSize: '120%',
              }}
            >
              Aucun résultat trouvé
            </p>
          ) : (
            <Row className="mb-4 d-flex justify-content-center p-0" style={{ width: '' }}>
              <Stack>
                <Pagination
                  style={{ margin: 'auto', fontFamily: PoliceDefaut }}
                  size="large"
                  variant="outlined"
                  color="primary"
                  count={pagesNav}
                  page={page}
                  onChange={handleChangePage}
                  disabled={loading2 === true ? true : false}
                ></Pagination>
              </Stack>

              {/* <Col className=" d-flex justify-content-end">

                <Button
                  className="buttons-pagination"
                  disabled={
                    pagesNav.previous === null || loading2 === true
                      ? true
                      : false
                  }
                  onClick={() => pageChange(pagesNav.previous)}
                >
                  {"<"}
                </Button>
              </Col> */}
              {/* <Col sm='auto d-flex align-items-center'>2/5</Col> */}
              {/* <Col className=" d-flex justify-content-start">
                <Button
                  className="buttons-pagination"
                  disabled={
                    pagesNav.next === null || loading2 === true ? true : false
                  }
                  onClick={() => pageChange(pagesNav.next)}
                >
                  {">"}
                </Button>
              </Col> */}
            </Row>
          )}

          {/* <Row className='mb-4 d-flex justify-content-center p-0' style={{ width: 'fit-content' }}>
                        <Stack spacing={5}>
                            <Pagination style={{ margin: 'auto' }} className='' count={totalPages} page={page} onChange={handleChange} />
                        </Stack>
                    </Row> */}
        </Row>
      )}
    </Container>
  );
};

export default Participants;
